import { Box } from "@mui/material";
import AuthenticationSettings from "components/modules/Account/AuthenticationSettings/AuthenticationSettings";
import NotificationsTab from "components/modules/Account/NotificationsTab/NotificationsTab";
import ProfileTab from "components/modules/Account/ProfileTab/ProfileTab";
import Subscription from "components/modules/Subscription/Subscription";
import CustomNavTabs from "components/shared/CustomNavTabs";
import { getMonthDayYear, getSettingNavItems, SETTINGS } from "components/utils/accounts";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { accessActions } from "../../redux/slice/access.slice";
import { authActions } from "../../redux/slice/auth.slice";
import { uiActions } from "../../redux/slice/ui.slice";
import styles from "./Account.module.scss";
import { checkSinglePermission } from "components/shared/helper";
import { USER_PERMISSIONS } from "components/modules/Management/AccessManagement/helper";
import SystemUpdates from "components/modules/Account/SystemUpdates/SystemUpdates.jsx";

const Account = () => {
  const dispatch = useDispatch();
  const currentUser = useSelector(authActions.selectors.getCurrentUser);
  const userPermissions = useSelector(accessActions.selectors.getUserPermissions)
  const isTwoFaEnabled = currentUser?.isTwoFaEnabled;
  const [selectedTab, setSelectedTab] = useState(0);

  useEffect(() => {
    dispatch(uiActions.actions.setSelectedNav("Setting"));
  }, [dispatch]);

  const { year, month, day } = getMonthDayYear(currentUser?.dob);

  const handleSelectedTab = (newValue) => {
    setSelectedTab(newValue);
  };


  const renderTabContent = (selectedTab) => {
    const tabLabel = settingNavItems[selectedTab]?.label;

    switch (tabLabel) {
      case SETTINGS.PROFILE:
        return (
          <ProfileTab
            currentUser={currentUser}
            month={month}
            day={day}
            year={year}
            country={currentUser.country}
            userId={currentUser._id}
          />
        );
      case SETTINGS.NOTIFICATIONS:
        return <NotificationsTab isTwoFaEnabled={isTwoFaEnabled} />;
      case SETTINGS.AUTHENTICATION:
        return <AuthenticationSettings isTwoFaEnabled={isTwoFaEnabled} />;
      case SETTINGS.BILLING:
        return <Subscription cols={12} />;
      case SETTINGS.SYSTEM_UPDATES:
        return <SystemUpdates/>;
      default:
        return null;
    }
  };



  const settingNavItems = getSettingNavItems({
    isNotificationAllowed: checkSinglePermission(USER_PERMISSIONS.NOTIFICATIONS, userPermissions, currentUser?.role),
    isAuthenticationAllowed: checkSinglePermission(USER_PERMISSIONS.VIEW_AUTHENTICATION, userPermissions, currentUser?.role),
    isBillingAllowed: checkSinglePermission(USER_PERMISSIONS.VIEW_BILLING, userPermissions, currentUser?.role),
    isSystemUpdatesAllowed: checkSinglePermission("", [], currentUser?.role), //To Allow only for admin
  })

  return (
    <Box className={styles.accountContainer}>
      <Box className={styles.tabs}>
        <CustomNavTabs
          selectedTab={selectedTab}
          handleSelectedTab={handleSelectedTab}
          navItems={settingNavItems}
        />
      </Box>

      {renderTabContent(selectedTab)}
    </Box>

  );
};

export default Account;
